import React, { useState } from "react";
import Button from "react-bootstrap/esm/Button";
import Modal from "react-bootstrap/esm/Modal";
import { useI18n } from "../../lib/i18n/i18n_provider";

import "./faqs.css";

export function Faqs(props: { html: string }) {
  const { fbt } = useI18n();
  const [show, setShow] = useState(false);

  return (
    <div data-testid="faqs" className="pt-4">
      <span>{fbt("Have more questions?")}</span>{" "}
      <Button variant="link" onClick={() => setShow(true)} className="p-0">
        {fbt("Visit our FAQ")}
      </Button>
      <Modal
        show={show}
        fullscreen="sm-down"
        size="lg"
        onHide={() => setShow(false)}
        className="faq-modal header-center"
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">{fbt("Frequently asked questions")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className="faqs"
            dangerouslySetInnerHTML={{ __html: props.html }}
          />
          <div className="d-grid gap-2 mt-3">
            <Button variant="primary" onClick={() => setShow(false)}>
              {fbt("Close")}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
